import { FC } from 'react';
import { Box } from 'components/base/layout/Box';
import { Typography } from 'components/atoms/Typography';
import { Button } from 'components/atoms/Button';
import { useAppNavigation } from 'hooks/common/useAppNavigation';
import { SearchIcon } from 'assets/icons/SearchIcon';
import { ArrowBackIcon } from 'assets/icons/ArrowBackIcon';
import { HomeIcon } from 'assets/icons/HomeIcon';
import {
  pageWrapperStyles,
  cardStyles,
  iconRingStyles,
  errorCodeStyles,
  accentStyles,
  dividerStyles,
  headingStyles,
  subtitleStyles,
  actionsStyles,
  searchIconStyles,
} from './style';

export const NotFoundPage: FC = () => {
  const { goBack, navigateTo } = useAppNavigation();

  return (
    <Box sx={pageWrapperStyles}>
      <Box sx={cardStyles}>
        <Box sx={iconRingStyles}>
          <SearchIcon sx={searchIconStyles} />
        </Box>

        <Typography sx={errorCodeStyles}>
          4
          <Box component="span" sx={accentStyles}>
            0
          </Box>
          4
        </Typography>

        <Box sx={dividerStyles} />

        <Typography variant="h5" sx={headingStyles}>
          Page Not Found
        </Typography>

        <Typography variant="body1" sx={subtitleStyles}>
          The page you requested could not be found or may have been removed.
        </Typography>

        <Box sx={actionsStyles}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={goBack}
          >
            Go Back
          </Button>
          <Button
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={() => navigateTo('/')}
          >
            Go to Home
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
